'use client'

import { cn } from '@/lib/utils'

/**
 * Single notebook content width system — hero, tabs, blocks share one column.
 */
export function NotebookContentColumn({ children, className }) {
  return (
    <div className={cn('nb-content-column', className)}>
      <div className="nb-content-column__track">{children}</div>
    </div>
  )
}
